module.exports = __webpack_public_path__ + "img/no-camera.a3e2aabd.png";